/**
 * Copyright © Pronko Consulting Ltd. All rights reserved.
 */

import ClientGallery from "./modules/ClientGallery";
import PopupFormToggle from "./modules/PopupFormToggle";

const clientGallery = new ClientGallery();
clientGallery.animationMarquee();

document.addEventListener('DOMContentLoaded', e => {
    new PopupFormToggle(document.querySelectorAll('[data-popup]'));
});
